module.exports = __webpack_public_path__ + "img/d260c8b.png";